import { supabase } from '../lib/supabase';
import { logger } from '../lib/logger';

export interface UserProfile {
  id: string;
  user_id: string;
  username: string;
  created_at: string;
}

export async function fetchUserProfile(): Promise<UserProfile | null> {
  try {
    logger.performance.start('fetchUserProfile');
    
    const { data: session } = await supabase.auth.getSession();
    if (!session?.session?.user) {
      throw new Error('User must be authenticated to fetch their profile');
    }
    
    const userId = session.session.user.id;
    
    // Fetch user profile data from the profiles table
    const { data, error } = await supabase
      .from('profiles')
      .select('id, user_id, username, created_at')
      .eq('user_id', userId)
      .single();
    
    if (error) {
      logger.error(error, 'fetchUserProfile');
      throw error;
    }
    
    logger.performance.end('fetchUserProfile');
    return data;
  } catch (error) {
    logger.error(error, 'fetchUserProfile');
    return null;
  }
}
